/**
 * True when [url] resolves to this site's /app-store route (would loop).
 * External store URLs that merely contain the substring "/app-store" are allowed.
 */
export function isSelfAppStoreRedirect(
  url: string,
  origin: string = typeof window !== 'undefined' ? window.location.origin : ''
): boolean {
  if (!url || !origin) {
    return false;
  }
  try {
    const target = new URL(url, origin);
    return (
      target.origin === new URL(origin).origin &&
      target.pathname.replace(/\/+$/, '') === '/app-store'
    );
  } catch {
    return false;
  }
}
